import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Fade from "@material-ui/core/Fade";
import Button from "./Button";
import "./styles/DialogShell.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

/**
 * DialogShell - Reusable dialog wrapper
 * @param {Object} props
 * @param {boolean} props.open - Dialog open state
 * @param {Function} props.onClose - Close handler
 * @param {string} props.title - Dialog title
 * @param {string} props.subtitle - Optional line under the title
 * @param {string} props.message - Dialog message, used when there are no children
 * @param {string} props.type - Message tone ('info', 'success', 'error')
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {React.ReactNode} props.children - Custom content
 * @param {Array} props.actions - Array of { label, onClick, variant, disabled, loading }
 */
const DialogShell = ({
  open,
  onClose,
  title,
  subtitle,
  message,
  type = "info",
  size = "md",
  children,
  actions = [],
}) => {
  const titleId = "dsDialogTitle";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      /* MUI's prop is TransitionComponent; the old `transition` prop was
         silently ignored, so the dialog never animated. */
      TransitionComponent={Transition}
      aria-labelledby={titleId}
      PaperProps={{ className: "dialogShellPaper" }}
      BackdropProps={{ className: "dialogShellBackdrop" }}
    >
      <DialogContent className="dialogShellContent">
        <div className={`dialogShellCard size-${size}`}>
          <div className="dialogShellHeader">
            <div className="dialogShellHeading">
              <div className="dialogShellTitle" id={titleId}>
                {title}
              </div>
              {subtitle && (
                <div className="dialogShellSubtitle">{subtitle}</div>
              )}
            </div>
            <IconButton
              onClick={onClose}
              size="small"
              aria-label="Close dialog"
              className="dialogShellCloseButton"
            >
              <CloseIcon className="dialogShellCloseIcon" />
            </IconButton>
          </div>

          {children || (
            <div className={`dialogShellMessage ${type}`}>{message}</div>
          )}

          {actions.length > 0 && (
            <div className="dialogShellActions">
              {actions.map((action, idx) => (
                <Button
                  key={idx}
                  onClick={action.onClick}
                  variant={action.variant || "secondary"}
                  disabled={action.disabled}
                  loading={action.loading}
                  className={`dialogShellButton ${action.variant || "default"}`}
                >
                  {action.label}
                </Button>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogShell;
